module.exports = __webpack_public_path__ + "img/clock-counter-clockwise.a2f02623.svg";